<template>
  <div class="box1">
    <div class="bujinqi">
      <Steps :current="num">
        <Step content="提交订单"></Step>
        <Step content="支付成功"></Step>
        <Step content="商品发货"></Step>
        <Step content="完成"></Step>
      </Steps>
    </div>

    <div class="xixin_zhuce" v-show="num == 1">
      <div class="zi">商品名称：{{ pockname }}</div>
      <br />
      <div class="zi">交易金额：¥{{ money }}</div>
      <br />
      <div class="zi">订单编号：{{ data }}</div>
      <br />
      <div class="zi">支付方式：{{ num1 }}</div>
      <br />
      <div class="zi">支付时间：{{time}}</div>
      <br />
      <div class="zi">发票类型：约2个工作日后开具发票</div>
      <br />
      <div class="next" @click="cl()">查看课程</div>
      <div class="fh" @click="cl1()">返回首页</div>
    </div>
    <div class="xixin_zhuce" v-show="num == 0">
      <div class="zi">商品名称：{{ pockname }}</div>
      <div class="zi">订单号：{{ data }}</div>
      <div class="zi">状态：提交订单成功</div>
      <div class="zi">(仅支持公对公账户汇款)</div>
      <br />
      <div class="next" @click="cl()">返回项目</div>
      <div class="fh" @click="cl1()">返回首页</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 1,
      num1: "",
      data: "",
      userId: "",
      pockname: "",
      money: "",
      time:null
    };
  },
  created() {
    this.cl3();
    
    let myDate = new Date()

    this.time = myDate.getFullYear()+'年 '+(myDate.getMonth()+1)+'月 '+ myDate.getDate()+'日';
  },
  methods: {
    cl() {
      this.$router.push("/myTraining");
    },
    cl1() {
      this.$router.push("/index");
    },
    cl3() {
      this.userId = this.$route.query.userId;
      this.data = this.$route.query.data;
      this.pockname = this.$route.query.pockname;
      this.num1 = this.$route.query.num;
      this.money = this.$route.query.money;
       if (this.$route.query.num == 5) {
        this.num1 = "中国建设银行";
        this.num = 1;
      }  else {
        this.num = 0;
      }

    },
  },
};
</script>
<style scoped>
.box1 {
  width: 1200px;
  height: 800px;
}
.bujinqi {
  width: 1000px;
  height: 70px;
  margin-top: 60px;
  margin-left: 500px;
}
.xixin_zhuce {
  width: 500px;
  height: 500px;

  margin-left: 750px;
}

.zi {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 20px;
  color: #333333;
}
.next {
  width: 180px;
  height: 48px;
  background: #3562e8;
  border-radius: 8px;
  margin-top: 120px;
  margin-left: -50px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.fh {
  width: 180px;
  height: 48px;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  margin-top: -50px;
  margin-left: 300px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
</style>